import type { Player } from "@shared/index";

interface Props {
  players: Player[];
  sequence: number[];
  onChange: (sequence: number[]) => void;
  title?: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export default function ThrowOrderPicker({
  players,
  sequence,
  onChange,
  title = "Spielreihenfolge",
  confirmLabel = "Übernehmen",
  onConfirm,
  onCancel,
}: Props) {
  const move = (from: number, dir: -1 | 1) => {
    const to = from + dir;
    if (to < 0 || to >= sequence.length) return;
    const next = [...sequence];
    const tmp = next[from]!;
    next[from] = next[to]!;
    next[to] = tmp;
    onChange(next);
  };

  return (
    <div className="w-full max-w-lg rounded-3xl border border-amber-glow/30 bg-ink-800 p-6 text-left shadow-glow">
      <div className="text-xs uppercase tracking-[0.35em] text-amber-glow">{title}</div>
      <p className="mt-2 text-sm text-slate-400">Wer zuerst wirft, steht oben. Reihenfolge mit den Pfeilen ändern.</p>
      <ol className="mt-4 grid gap-2">
        {sequence.map((playerIndex, pos) => {
          const player = players[playerIndex];
          return (
            <li key={`${playerIndex}-${pos}`} className="flex items-center gap-2 rounded-2xl bg-ink-950 px-3 py-2">
              <span className="w-8 font-display text-2xl text-amber-glow">{pos + 1}</span>
              <span className="min-w-0 flex-1 truncate font-bold text-white">
                {player?.name || `Spieler ${playerIndex + 1}`}
              </span>
              <button
                type="button"
                className="min-h-touch rounded-xl bg-ink-700 px-3 text-sm font-bold disabled:opacity-30"
                disabled={pos === 0}
                onClick={() => move(pos, -1)}
                aria-label="Nach oben"
              >
                ↑
              </button>
              <button
                type="button"
                className="min-h-touch rounded-xl bg-ink-700 px-3 text-sm font-bold disabled:opacity-30"
                disabled={pos === sequence.length - 1}
                onClick={() => move(pos, 1)}
                aria-label="Nach unten"
              >
                ↓
              </button>
            </li>
          );
        })}
      </ol>
      <button type="button" className="pad-btn mt-5 w-full bg-amber-glow text-ink-950" onClick={onConfirm}>
        {confirmLabel}
      </button>
      {onCancel ? (
        <button type="button" className="pad-btn mt-2 w-full bg-ink-700" onClick={onCancel}>
          Abbrechen
        </button>
      ) : null}
    </div>
  );
}
